export enum BusinessWaitingDays {
  ONE_DAY = 'ONE_DAY',
  TWO_DAYS = 'TWO_DAYS',
  FOUR_DAYS = 'FOUR_DAYS',
  SEVEN_DAYS = 'SEVEN_DAYS',
  FOURTEEN_DAYS = 'FOURTEEN_DAYS',
  THIRTY_DAYS = 'THIRTY_DAYS',
  SIXTY_DAYS = 'SIXTY_DAYS',
  NINETY_DAYS = 'NINETY_DAYS',
  ONE_HUNDRED_TWENTY_DAYS = 'ONE_HUNDRED_TWENTY_DAYS',
}

export const BUSINESS_WAITING_DAYS_VALUES = Object.values(BusinessWaitingDays);

export const getBusinessWaitingDaysLabel = (
  waitingDays: BusinessWaitingDays
) => {
  switch (waitingDays) {
    case BusinessWaitingDays.ONE_DAY:
      return $localize`1 jour`;
    case BusinessWaitingDays.TWO_DAYS:
      return $localize`2 jours`;
    case BusinessWaitingDays.FOUR_DAYS:
      return $localize`4 jours`;
    case BusinessWaitingDays.SEVEN_DAYS:
      return $localize`7 jours`;
    case BusinessWaitingDays.FOURTEEN_DAYS:
      return $localize`14 jours`;
    case BusinessWaitingDays.THIRTY_DAYS:
      return $localize`30 jours`;
    case BusinessWaitingDays.SIXTY_DAYS:
      return $localize`60 jours`;
    case BusinessWaitingDays.NINETY_DAYS:
      return $localize`90 jours`;
    case BusinessWaitingDays.ONE_HUNDRED_TWENTY_DAYS:
      return $localize`120 jours`;
    default:
      return '';
  }
};
